import { QR_QUIET_ZONE, qrSvgDocument, qrViewBoxSize, type QrMatrix } from "./qr";

/** Pixels per module: a typical code comes out around 700px, enough to print a table card sharply. */
const PNG_SCALE = 16;
const REVOKE_AFTER_MS = 30_000;

/** Draw the code straight onto a canvas, so the PNG needs no image load and no `img-src` allowance. */
export function qrPngBlob(matrix: QrMatrix): Promise<Blob> {
  const canvas = document.createElement("canvas");
  canvas.width = qrViewBoxSize(matrix) * PNG_SCALE;
  canvas.height = canvas.width;
  const context = canvas.getContext("2d");
  if (!context) return Promise.reject(new Error("canvas 2d context unavailable"));
  context.fillStyle = "#fff";
  context.fillRect(0, 0, canvas.width, canvas.height);
  context.fillStyle = "#000";
  matrix.forEach((cells, row) => {
    cells.forEach((dark, column) => {
      if (!dark) return;
      context.fillRect(
        (column + QR_QUIET_ZONE) * PNG_SCALE,
        (row + QR_QUIET_ZONE) * PNG_SCALE,
        PNG_SCALE,
        PNG_SCALE,
      );
    });
  });
  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => (blob ? resolve(blob) : reject(new Error("PNG encoding failed"))));
  });
}

export function qrSvgBlob(matrix: QrMatrix): Blob {
  return new Blob([qrSvgDocument(matrix)], { type: "image/svg+xml" });
}

export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.click();
  // Some browsers start the download asynchronously, so the URL has to outlive this call.
  window.setTimeout(() => URL.revokeObjectURL(url), REVOKE_AFTER_MS);
}
